module.exports = __webpack_public_path__ + "static/06-984159cb417bd949b397e5d99984d919.jpg";